// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Pj-\\+LJIO4rLsF7IajRWCOw\\=\\={color:var(--text-primary-light);font-size:1.6rem;font-weight:300}@media screen and (min-width:768px){.Pj-\\+LJIO4rLsF7IajRWCOw\\=\\={font-size:1.8rem}}.Pj-\\+LJIO4rLsF7IajRWCOw\\=\\= div>p{padding-left:0;padding-right:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rteParserPrimaryLight": "Pj-+LJIO4rLsF7IajRWCOw=="
};
module.exports = ___CSS_LOADER_EXPORT___;
